import {
    CustomOnlineManufacturerTrainingActions,
    CustomOnlineManufacturerTrainingState,
} from "@crescentParts/Store/OnlineManufacturerTraining/OnlineManufacturerTrainingsReducer";
import { Handler } from "@crescentParts/Types/CrescentHandlerCreator";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type Parameter = {
    trainings: any[];
    queryParams: any;
    initialLoad: boolean;
};

type CustomHandlerType = Handler<
    Parameter,
    Parameter,
    CustomOnlineManufacturerTrainingActions,
    CustomOnlineManufacturerTrainingState
>;

type AppliedFilter = {
    filterNames: string[];
    filterType: string;
};

type AppliedFilters = AppliedFilter[];

const generateDynamicFilters = (trainings: any, queryParams: any) => {
    // Generate dynamic filter options
    const typeFilters = generateFilterArray("trainingType", trainings, queryParams);
    return {
        typeFilters,
    };
};

const generateFilterArray = (filterType: string, trainings: any, queryParams: any): any => {
    const filterSet = new Set<string>();
    const filterArr: any = [];
    trainings.forEach((training: any) => {
        if (training?.fields[filterType]) {
            filterSet.add(training?.fields[filterType]);
        }
    });

    filterSet.forEach((item: string) => {
        filterArr.push({ name: item, filterType });
    });
    return filterArr;
};

const applyFilters = (queryParams: any, trainings: any[]) => {
    const appliedFilters: AppliedFilters = [];
    const selectedFilterNamesArr: string[] = [];
    for (const key in queryParams) {
        const filterNames = queryParams[key].toLowerCase().split(",");
        appliedFilters.push({ filterType: key, filterNames });
        filterNames.forEach((item: string) => {
            selectedFilterNamesArr.push(item);
        });
    }
    const filteredTrainings =
        selectedFilterNamesArr.length === 0 ? [...trainings] : filterTrainings(appliedFilters, trainings);
    return {
        selectedFilterNamesArr,
        appliedFilters,
        filteredTrainings,
    };
};

const filterTrainings = (appliedFilters: string | any[], trainings: any[]) => {
    const updatedFilteredTrainings = trainings.filter(function (item) {
        let result = true;
        for (let i = 0; i < appliedFilters.length; i++) {
            if (
                appliedFilters[i].filterNames.length > 0 &&
                appliedFilters[i]["filterNames"].findIndex(
                    (val: string) => val.toLowerCase() === item?.fields[appliedFilters[i]["filterType"]]?.toLowerCase(),
                ) === -1
            ) {
                result = false;
            }
        }
        return result;
    });
    return updatedFilteredTrainings;
};

export const DispatchGenerateDynamicFilters: CustomHandlerType = props => {
    const { trainings, queryParams, initialLoad } = props.parameter;
    if (initialLoad) {
        (props as unknown as any).dispatch({
            type: "OnlineManufacturerTraining/GenerateDynamicFilters",
            payload: generateDynamicFilters(trainings, queryParams),
        });
    }
};

export const DispatchApplyFilters: CustomHandlerType = props => {
    const { trainings, queryParams } = props.parameter;
    props.dispatch({
        type: "OnlineManufacturerTraining/ApplyFiltersFromUrl",
        payload: applyFilters(queryParams, trainings),
    });
};

export const chain = [DispatchGenerateDynamicFilters, DispatchApplyFilters];

const setFilters = createHandlerChainRunner(chain, "SetFilters");
export default setFilters;
